/*
Required Includes
*/

// jQuery
const $ = require('jquery');

// Lottieplayer
require("@lottiefiles/lottie-player");

// Slick
slick = require('slick-carousel');

// Headroom
const Headroom = require('headroom.js');
const menuMain = document.querySelector('.menu');
if (menuMain) {
	const headroom = new Headroom(menuMain, {
		offset: 30,
		tolerance: { up: 0, down: 5 },
	});
	headroom.init();
}

// Optiscroll
optiscroll = require('optiscroll');
const Optiscroll = require('optiscroll');
document.addEventListener("DOMContentLoaded", () => {
    const updateOptiscrollHeights = () => {
        document.querySelectorAll(".optiscroll").forEach((optiscroll) => {
            const scrollHeight = optiscroll.dataset.scrollHeight;

            let heightValue = null;

            if (scrollHeight) {
                heightValue = scrollHeight.endsWith("px")
                    ? parseInt(scrollHeight, 10) + "px"
                    : (
                        optiscroll.querySelector(scrollHeight)?.offsetHeight
                    )?.toString() + "px" || null;
            }

            optiscroll.style.height = heightValue || "";
            optiscroll.classList.toggle("scroll--not-fixed", !heightValue);
        });
    };

    let resizeTimeout;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateOptiscrollHeights, 200);
    });

    updateOptiscrollHeights();

    document.querySelectorAll(".optiscroll").forEach((element) => {
        const instance = new Optiscroll(element, { autoUpdate: true });
        const contentElement = element.querySelector(".optiscroll-content");
        const isHorizontal = element.classList.contains("scroll--horizontal"); // Check for horizontal class

        if (!contentElement) {
            console.warn(
                "Optiscroll content element not found. Draggable functionality will not work."
            );
            return;
        }

        contentElement.querySelectorAll("a").forEach((link) => {
            link.setAttribute("draggable", "false");
        });

        // Disable image dragging by default
        contentElement.querySelectorAll('img').forEach(img => {
            img.setAttribute('draggable', false);
        });

        let isDragging = false;
        let startX = 0;
        let startY = 0;
        let scrollLeft = 0;
        let scrollTop = 0;
        const tolerance = 5;
        let moved = false;

        // Function to update scroll position classes
        const updateScrollClasses = () => {
            const {
                scrollLeft,
                scrollTop,
                scrollWidth,
                scrollHeight,
                clientWidth,
                clientHeight,
            } = contentElement;

            const isTop = scrollTop === 0;
            const isBottom = scrollTop + clientHeight >= scrollHeight - 1;
            const isLeft = scrollLeft === 0;
            const isRight = scrollLeft + clientWidth >= scrollWidth - 1;

            if (isHorizontal) {
                // Horizontal scroll classes (left/right)
                element.classList.toggle("scroll--left", isLeft);
                element.classList.toggle("scroll--not-left", !isLeft);
                element.classList.toggle("scroll--right", isRight);
                element.classList.remove("scroll--top", "scroll--not-top", "scroll--bottom"); // Remove vertical classes
            } else {
                // Vertical scroll classes (top/bottom)
                element.classList.toggle("scroll--top", isTop);
                element.classList.toggle("scroll--not-top", !isTop);
                element.classList.toggle("scroll--bottom", isBottom);
                element.classList.remove("scroll--left", "scroll--not-left", "scroll--right"); // Remove horizontal classes
            }
        };

        // Initial update
        updateScrollClasses();

        // Update on scroll events using Optiscroll's events
        element.addEventListener("scrollstart", updateScrollClasses);
        element.addEventListener("scrollstop", updateScrollClasses);

        contentElement.addEventListener("mousedown", (e) => {
            isDragging = true;
            startX = e.pageX - contentElement.offsetLeft;
            startY = e.pageY - contentElement.offsetTop;
            scrollLeft = contentElement.scrollLeft;
            scrollTop = contentElement.scrollTop;
            contentElement.style.cursor = "grab";
            element.classList.add("no-scroll");
            moved = false;
            contentElement.classList.add("disable-select"); // Disable selection on mousedown
        });

        contentElement.addEventListener("mouseleave", () => {
            isDragging = false;
            contentElement.style.cursor = "default";
            element.classList.remove("no-scroll");
            contentElement.classList.remove("disable-select"); //Re-enable selection on mouseleave
        });

        contentElement.addEventListener("mouseup", (e) => {
            isDragging = false;
            contentElement.style.cursor = "default";
            element.classList.remove("no-scroll");

            if (moved) {
                e.preventDefault();
                e.stopPropagation();
            }
            contentElement.classList.remove("disable-select"); //Re-enable selection on mouseup
        });

        contentElement.addEventListener("mousemove", (e) => {
            if (!isDragging) return;
            e.preventDefault();

            const x = e.pageX - contentElement.offsetLeft;
            const y = e.pageY - contentElement.offsetTop;
            const walkX = x - startX;
            const walkY = y - startY;
            contentElement.scrollLeft = scrollLeft - walkX;
            contentElement.scrollTop = scrollTop - walkY;

            moved = Math.abs(walkX) > tolerance || Math.abs(walkY) > tolerance;
        });

        contentElement.addEventListener("click", (e) => {
            if (moved) {
                e.preventDefault();
                e.stopPropagation();
            }
        }, { capture: true });
    });
});

// Quicklink
const quicklink = require('quicklink');
window.addEventListener('load', () => {
	quicklink.listen({
		ignores: [
			/\/cart/,
			/\/checkout/,
			/\/account/,
			/\/admin/,
			(uri) => uri.includes('logout')
		]
	});
	console.log('Quicklink initialized');

	const specScript = document.createElement('script');
	specScript.type = 'speculationrules';
	specScript.textContent = JSON.stringify({
		"prerender": [
			{
				"source": "document",
				"where": {
					"and": [
						{ "href_matches": "/*" },
						{ "not": { "href_matches": ["/cart", "/checkout", "/account"] } }
					]
				},
				"eagerness": "eager"
			}
		]
	});
	document.head.appendChild(specScript);
});

/*
Theme Customization
*/

// On Document Ready
$(document).ready(function() {

// Menu Desktop
// ------------------------------
// Configuration
// ------------------------------
const smallScreen = window.matchMedia("(max-width: 990px)");
const mediumScreen = window.matchMedia("(min-width: 991px) and (max-width: 1198px)");
const largeScreen = window.matchMedia("(min-width: 1199px)");

const MenuConfig = {
	mainHoverDelay: 300,
	innerHoverDelay: 200,
	closeDelay: 100,
	afterClose: 300,
};

const MenuState = {
	selectedCategories: { main: null, sub: null, subsub: null },
	menuIsOpen: false,
	searchIsOpen: false,
	fadeOutTimeout: null,
	isTouchDevice: window.matchMedia("(pointer: coarse)").matches
};

// ------------------------------
// Core Overlay & Menu Functions
// ------------------------------
function openOverlay() {
	if (!$(".menu-overlay").is(":visible")) {
		$(".menu-overlay").stop(true, true).fadeIn(700);
		$(".belco-manager").addClass('belco--hide');
		$('.menu-curtain').removeClass('fade-out').addClass('fade-in');
	}
}

function closeOverlay() {
	if ($(".menu-overlay").is(":visible")) {
		$(".menu-overlay").fadeOut(300);
		$(".belco-manager").removeClass('belco--hide');
		$('.menu-curtain').removeClass('fade-in').addClass('fade-out');
	}
}

function openDesktopMenu() {
	if (!$(".menu-desktop").is(":visible")) {
		$(".menu-desktop").stop(true, true).slideDown(300);
		$('.menu').addClass('active');
		$('body').addClass('no-scroll');
	}
}

function closeDesktopMenu() {
	if ($(".menu-desktop").is(":visible")) {
		$(".menu-desktop").slideUp(300);
		$('.menu').removeClass('active');
		$('body').removeClass('no-scroll');
	}
}

function playerMenuOpen() {
    const players = $('.menu-menu').find('.menu-animation--light, .menu-animation--dark').get();
    
    $('.menu-menu').addClass('active');
    $('.menu').addClass('menu-open');
    $('.menu-overlay').addClass('active');
    $('body').addClass('no-scroll');

    players.forEach(player => {
        player.setDirection(1);
        player.play();
    });
}

function playerMenuClose() {
    const players = $('.menu-menu').find('.menu-animation--light, .menu-animation--dark').get();
    
    $('.menu-menu').removeClass('active');
    $('.menu').removeClass('menu-open');
    $('.menu-overlay').removeClass('active');
    $('body').removeClass('no-scroll');

    players.forEach(player => {
        player.setDirection(-1);
        player.play();
    });
}

function closeButtonGroup() {
	setTimeout(() => {
		$('.menu-mobile .menu-buttongroup .menu-group').hide();
	}, MenuConfig.afterClose);
}

// For other scripts to close everything at once.
function closeMenuAndOverlay() {
	closeMenu();
	closeOverlay();
	closeDesktopMenu();
	playerMenuClose();
	closeButtonGroup();
}

// ------------------------------
// Menu Open/Close / Switching
// ------------------------------
function openMenu() {
	clearTimeout(MenuState.fadeOutTimeout);
	playerMenuOpen();
	openOverlay();
	openDesktopMenu();
	MenuState.menuIsOpen = true;

	if (smallScreen.matches) {
		setTimeout(() => {
			$('.menu-listgroup[data-order="0"]').addClass('ghost-level--show');
			$('.menu-listgroup[data-order="0"] .menu-list[data-level="0"]').addClass('ghost-level--show');
			$('.menu-listgroup[data-order="0"] .menu-list[data-level="0"] .menu-list-scroll').addClass('ghost-list--show');
		}, 50);
	}
}

function closeMenu() {
	playerMenuClose();
	$(".menu-item").removeClass("active");
	$(".menu-listgroup").removeClass('group-level--show ghost-level--show');
	$('.menu-list').removeClass('ghost-level--show main-level--show sub-level--show subsub-level--show');
	MenuState.menuIsOpen = false;
	selectionHistory.splice(0, selectionHistory.length);
}

function switchGroup(order) {
	$('.menu-listgroup').removeClass('ghost-level--show group-level--show');
	$(".menu-item", ".menu-list-scroll").removeClass("active");
	$('.menu-list').removeClass('sub-level--show subsub-level--show');
	$('.menu-list .menu-list-scroll').removeClass('sub-list--show subsub-list--show');
	$(".menu-result").removeClass('results--show');

	const $group = $(`.menu-listgroup[data-order="${order}"]`);
	if ($group.length) {
		$group.addClass('group-level--show');
		$('.menu-list', $group).first().addClass('main-level--show');
		$('.menu-list-scroll', $group).first().addClass('main-list--show');
	}
}

// ------------------------------
// Category Selection
// ------------------------------

let selectionHistory = [];

$(".menu-back").on("click", function () {
	if (selectionHistory.length > 0) {
		// Get the last clicked element
		let $lastItem = selectionHistory[selectionHistory.length - 1];

		var storedElement = $lastItem;
		var storedListItem = $lastItem.closest('li');
		var storedListScroll = $lastItem.closest('.menu-list-scroll');
		var storedList = $lastItem.closest('.menu-list');
		var storedGroup = $lastItem.closest('.menu-listgroup');

		let $secondlastItem = selectionHistory[selectionHistory.length - 2];
		var mobileGroupName = $('.menu-mobile-groupname');
		if($secondlastItem){
			var secondstoredListItem = $secondlastItem.closest('li');
			var storedCategoryName = secondstoredListItem.data('category-name');
			var storedCategoryURL = secondstoredListItem.data('category-url');

			if(storedCategoryName){
				mobileGroupName.html(storedCategoryName);

				var buttongroup = $('.menu-group[data-buttongroup="menu-level-2"]');
				if (storedCategoryURL === undefined) {
					buttongroup.find('.menu-run').prop('disabled', true);
					buttongroup.find('.menu-run').attr('data-url', '');
				} else {
					buttongroup.find('.menu-run').removeAttr('disabled', true);
					buttongroup.find('.menu-run').attr('data-url', storedCategoryURL);
				}
				buttongroup.find('.menu-run > span > span').html(storedCategoryName.toLowerCase());
				$('.menu-buttongroup .menu-group').hide();
				buttongroup.css('display', 'flex');

			} else {
				mobileGroupName.html("not stored");
			}
		} else {
			mobileGroupName.html("Menu");

			$('.menu-buttongroup .menu-group').hide();
			var buttongroup = $('.menu-group[data-buttongroup="menu-main"]');
			buttongroup.css('display', 'flex');
		}

		$('.menu-listgroup').removeClass('group-level--show ghost-level--show');
		$('.menu-list').removeClass('ghost-level--show main-level--show sub-level--show subsub-level--show');
		$('.menu-list-scroll').removeClass('ghost-list--show main-list--show sub-list--show subsub-list--show');
		$(".menu-result").removeClass("results--show");
		
		if(storedListScroll.hasClass('ghostcategory-list')){
			storedGroup.addClass('ghost-level--show');
			storedList.addClass('ghost-level--show');
			storedListScroll.addClass('ghost-list--show');
		} else if(storedListScroll.hasClass('maincategory-list')){
			storedGroup.addClass('group-level--show');
			storedList.addClass('main-level--show');
			storedListScroll.addClass('main-list--show');
		} else if(storedListScroll.hasClass('subcategory-list')){
			storedGroup.addClass('group-level--show');
			storedList.addClass('sub-level--show');
			storedListScroll.addClass('sub-list--show');
		} else if(storedListScroll.hasClass('subsubcategory-list')){
			storedGroup.addClass('group-level--show');
			storedList.addClass('subsub-level--show');
			storedListScroll.addClass('subsub-list--show');
		} else {
			// Results
		}

		// Remove the last clicked element
		selectionHistory.pop();
		// console.log("History:", selectionHistory.map(el => el.get(0))); 
	}
});

function checkParentCategory(item) {
	const $item = $(item);
	const $li = $item.closest("li");
	const parentUl = $item.closest("ul");
	const parentList = $item.closest('.menu-list');
	const parentGroup = $item.closest('.menu-listgroup');

	if (smallScreen.matches) {
		$('.menu-listgroup').removeClass('group-level--show ghost-level--show');
		$('.menu-list').removeClass('main-level--show sub-level--show subsub-level--show');
		$('.menu-list-scroll').removeClass('main-list--show sub-list--show subsub-list--show');
		$(".menu-result").removeClass('results--show');
	}

	if (parentUl.hasClass("ghostcategory-list")) {
		const categoryId = $li.data("ghost-category-id");
		const categoryName = $li.data("category-name");
		const categoryURL = $li.data("category-url");
		const categoryImage = $li.find('.menu-image').clone();

		if (smallScreen.matches) {
			nextList = parentGroup.parent().find('[data-order="'+categoryId+'"]');
			if (nextList.length) {
				nextList.addClass('ghost-level--show');
				nextList.find('.menu-list[data-level="0"]').addClass('ghost-level--show');
				nextList.find('.menu-list[data-level="0"] .menu-list-scroll').addClass('sub-list--show');
				nextList.find('.menu-mobile-groupname').html(categoryName);
			} else {
				parentGroup.addClass("group-level--show");
				$(".menu-result").addClass("results--show");
				$(".menu-result").find('.menu-title h3').html(categoryName);
				$(".menu-result").find('.menu-all span span').html(categoryName);
				$(".menu-result").find('.menu-all').data('url', categoryURL);
				$(".menu-result").find(".menu-preview-image").empty().append(categoryImage);
			}
		}

		if (smallScreen.matches){
			var buttongroup = $('.menu-group[data-buttongroup="menu-level-2"]');
			if (categoryURL === undefined) {
				buttongroup.find('.menu-run').prop('disabled', true);
				buttongroup.find('.menu-run').attr('data-url', '');
			} else {
				buttongroup.find('.menu-run').removeAttr('disabled', true);
				buttongroup.find('.menu-run').attr('data-url', categoryURL);
			}
			buttongroup.find('.menu-run > span > span').html(categoryName.toLowerCase());
			$('.menu-buttongroup .menu-group').hide();
			buttongroup.css('display', 'flex');
		}

		selectionHistory.push(item);
		console.log('this was ghost level');

	} else if (parentUl.hasClass("maincategory-list")) {
		const categoryId = $li.data("category-id");
		const categoryURL = $li.data("category-url");
		const categoryName = $li.data("category-name");
		const categoryImage = $li.find('.menu-image').clone();
		MenuState.selectedCategories.main = $li.data("category-name");
		MenuState.selectedCategories.sub = null;
		MenuState.selectedCategories.subsub = null;

		if (smallScreen.matches) {
			parentGroup.find('.menu-list[data-level="0"]').removeClass('ghost-level--show');
		}

		if (!smallScreen.matches){
			parentGroup.find('.menu-list-scroll').removeClass('sub-list--show');
		}

		nextList = parentGroup.find('.menu-list[data-level="1"] .menu-list-scroll[data-category-id="'+categoryId+'"]');
		if (!smallScreen.matches){
			$('.menu-list').removeClass('sub-level--show subsub-level--show');
			$(".menu-result").removeClass('results--show');
			nextList.find('.menu-item').removeClass('active');
		}
		if (nextList.length) {
			parentGroup.addClass('group-level--show');
			parentGroup.find('.menu-list[data-level="1"]').addClass('sub-level--show');
			parentGroup.find('.menu-mobile-groupname').html(categoryName);
			nextList.addClass('sub-list--show');
		} else {
			parentGroup.addClass("group-level--show");
			$(".menu-result").addClass("results--show");
			$(".menu-result").find('.menu-title h3').html(categoryName);
			$(".menu-result").find('.menu-all span span').html(categoryName);
			$(".menu-result").find('.menu-all').data('url', categoryURL);
			$(".menu-result").find(".menu-preview-image").empty().append(categoryImage);
		}

		if (smallScreen.matches){
			var buttongroup = $('.menu-group[data-buttongroup="menu-level-2"]');
			if (categoryURL === undefined) {
				buttongroup.find('.menu-run').prop('disabled', true);
				buttongroup.find('.menu-run').attr('data-url', '');
			} else {
				buttongroup.find('.menu-run').removeAttr('disabled', true);
				buttongroup.find('.menu-run').attr('data-url', categoryURL);
			}
			buttongroup.find('.menu-run > span > span').html(categoryName.toLowerCase());
			$('.menu-buttongroup .menu-group').hide();
			buttongroup.css('display', 'flex');
		}
		
		selectionHistory.push(item);
		console.log('this was main level');

	} else if (parentUl.hasClass("subcategory-list")) {
		const categoryId = parentUl.data("category-id");
		const subcategoryId = $li.data("subcategory-id");
		const categoryName  = $li.data("category-name");
		const categoryURL = $li.data("category-url");
		const categoryImage = $li.find('.menu-image').clone();
		MenuState.selectedCategories.sub = $li.data("category-name");
		MenuState.selectedCategories.subsub = null;

		if (!smallScreen.matches){
			parentGroup.find('.menu-list-scroll').removeClass('subsub-list--show');
		}

		nextList = parentGroup.find('.menu-list[data-level="2"] .menu-list-scroll[data-category-id="'+subcategoryId+'"]');
		if (!smallScreen.matches){
			$('.menu-list').removeClass('subsub-level--show');
			$(".menu-result").removeClass('results--show');
			nextList.find('.menu-item').removeClass('active');
		}
		if (nextList.length) {
			parentGroup.addClass('group-level--show');
			parentGroup.find('.menu-list[data-level="2"]').addClass('subsub-level--show');
			parentGroup.find('.menu-mobile-groupname').html(categoryName);
			nextList.addClass('subsub-list--show');
		} else {
			parentGroup.addClass('group-level--show');
			parentGroup.find('.menu-mobile-groupname').html(categoryName);
			$(".menu-result").addClass('results--show');
			$(".menu-result").find('.menu-title h3').html(categoryName);
			$(".menu-result").find('.menu-all span span').html(categoryName);
			$(".menu-result").find('.menu-all').data('url', categoryURL);
			$(".menu-result").find(".menu-preview-image").empty().append(categoryImage);
		}

		if (smallScreen.matches){
			var buttongroup = $('.menu-group[data-buttongroup="menu-level-2"]');
			if (categoryURL === undefined) {
				buttongroup.find('.menu-run').prop('disabled', true);
				buttongroup.find('.menu-run').attr('data-url', '');
			} else {
				buttongroup.find('.menu-run').removeAttr('disabled', true);
				buttongroup.find('.menu-run').attr('data-url', categoryURL);
			}
			buttongroup.find('.menu-run > span > span').html(categoryName.toLowerCase());
			$('.menu-buttongroup .menu-group').hide();
			buttongroup.css('display', 'flex');
		}
		selectionHistory.push(item);
		console.log('this was sub level');

	} else if (parentUl.hasClass("subsubcategory-list")) {
		MenuState.selectedCategories.subsub = $li.data("category-name");
		const categoryName  = $li.data("category-name");
		const categoryURL = $li.data("category-url");
		const categoryImage = $li.find('.menu-image').clone();

		if (smallScreen.matches) {
			parentGroup.addClass('group-level--show');
			parentGroup.find('.menu-mobile-groupname').html(categoryName);
		}
		$(".menu-result").addClass('results--show');
		$(".menu-result").find('.menu-title h3').html(categoryName);
		$(".menu-result").find('.menu-all span span').html(categoryName);
		$(".menu-result").find('.menu-all').data('url', categoryURL);
		$(".menu-result").find(".menu-preview-image").empty().append(categoryImage);

		if (smallScreen.matches){
			var buttongroup = $('.menu-group[data-buttongroup="menu-results"]');
			if (categoryURL === undefined) {
				buttongroup.find('.menu-run').prop('disabled', true);
				buttongroup.find('.menu-run').attr('data-url', '');
			} else {
				buttongroup.find('.menu-run').removeAttr('disabled', true);
				buttongroup.find('.menu-run').attr('data-url', categoryURL);
			}
			buttongroup.find('.menu-run > span > span').html(categoryName.toLowerCase());
			$('.menu-buttongroup .menu-group').hide();
			buttongroup.css('display', 'flex');
		}

		selectionHistory.push(item);
		console.log('this was subsub level');
	}

	$(".menu-console pre").html(
		`${MenuState.selectedCategories.main} / ${MenuState.selectedCategories.sub} / ${MenuState.selectedCategories.subsub}`
	);
}

// ------------------------------
// Bind Menu Interactions
// ------------------------------
function initMainMenuInteractions() {
	$(".menu-item, .menu-position, .menu-right, .menu-mobile, .menu-main .menu-search").off(".menuInteraction");
	$(document).off(".menuInteraction");

	const menuItems = $(".menu-item", ".menu-middle .menu-list");

	function bindInteraction($el, handler) {
		if (MenuState.isTouchDevice) {
			$el.on("touchend.menuInteraction", function (e) {
				e.preventDefault();
				handler.call(this, e);
			});
		} else {
			$el.on("click.menuInteraction", function (e) {
				handler.call(this, e);
			});
		}
	}

	// Main Menu Items
	menuItems.each(function () {
		const $item = $(this);
		const order = $item.data("order");
		let hoverTimeout;

		if (!MenuState.isTouchDevice) {
			$item.on("mouseenter.menuInteraction", function () {
				hoverTimeout = setTimeout(() => {
					menuItems.removeClass("active");
					// $(".menu-listgroup, .menu-result").hide();
					$item.addClass("active");
					openMenu();
					switchGroup(order);
				}, MenuConfig.mainHoverDelay);
			});
			$item.on("mouseleave.menuInteraction", function () {
				clearTimeout(hoverTimeout);
			});
		}

		// Primary interaction for both touch and click.
		bindInteraction($item, function (e) {
			if ($item.hasClass("active")) {
				MenuState.fadeOutTimeout = setTimeout(() => {
					closeMenu();
					closeOverlay();
					closeDesktopMenu();
				}, MenuConfig.closeDelay);
			} else {
				menuItems.removeClass("active");
				$item.addClass("active");
				openMenu();
				switchGroup(order);
			}
		});
	});

	// Close menu if mouse leaves the main container (desktop)
	if (!MenuState.isTouchDevice) {
		$(".menu-position").on("mouseleave.menuInteraction", function () {
			MenuState.fadeOutTimeout = setTimeout(() => {
				closeMenu();
				closeOverlay();
				closeDesktopMenu();
			}, MenuConfig.closeDelay);
		});

		$(".menu-right").on("click.menuInteraction", function () {
			MenuState.fadeOutTimeout = setTimeout(() => {
				closeMenu();
				closeOverlay();
				closeDesktopMenu();
			}, MenuConfig.closeDelay);
		});
	} else {
		$(document).on("touchstart.menuInteraction", function (e) {
		if ($(e.target).closest(".reviews-modal, .reviews-buttongroup, localization-form").length > 0) {
	      return;
	    }

		const tappedInside = $(e.target).closest(".menu-desktop, .menu-mobile, .menu-item, .menu-main").length > 0;
		const tappedExcluded = $(e.target).closest(".placeholder").length > 0;

		if (tappedExcluded) {
				setTimeout(() => {
					closeMenu();
					openOverlay();
					openDesktopMenu();
				}, 150);
			} else if (!tappedInside) {
				setTimeout(() => {
					if (MenuState.menuIsOpen) {
						closeMenu();
						closeOverlay();
						closeDesktopMenu();
					}
				}, 150);
			}
		});
	}

	$(".menu-desktop .menu-list").each(function () {
		const innerItems = $(this).find(".menu-item");
		let hoverTimeout;
		innerItems.each(function () {
			const $item = $(this);
			if (!MenuState.isTouchDevice) {
				$item.on("mouseenter.menuInteraction", function () {
					hoverTimeout = setTimeout(() => {
						innerItems.removeClass("active");
						$item.addClass("active");
						checkParentCategory($item);
					}, MenuConfig.innerHoverDelay);
				});
				$item.on("mouseleave.menuInteraction", function () {
					clearTimeout(hoverTimeout);
				});
				$item.on("click.menuInteraction", function () {
					innerItems.removeClass("active");
					$item.addClass("active");
					checkParentCategory($item);
				});
			} else {
				let touchMoved = false;
				$item.on("touchstart.menuInteraction", function () {
					touchMoved = false;
				});
				$item.on("touchmove.menuInteraction", function () {
					touchMoved = true;
				});
				$item.on("touchend.menuInteraction", function (e) {
					if (touchMoved) return;
					e.preventDefault();
					innerItems.removeClass("active");
					$item.addClass("active");
					checkParentCategory($item);
				});
			}
		});
	});

	// Mobile Menu 
	$('.menu-menu').on('click', function () {
		if ($(this).hasClass('active')) {
			closeMenu();
		} else {
			openMenu();
			$('.menu-group[data-buttongroup="menu-main"]').css('display','flex');
		}
	});

	$('.menu-close').on('click', function () {
		closeMenuAndOverlay();
	});

	$('.menu-start-choice').on('click', function () {
		closeMenuAndOverlay();
	});

	$('.menu-run').on('click', function () {
		var href = $(this).data('url');
		window.location.href = href;
	});
}

// ------------------------------
// Bind Search Interactions
// ------------------------------
function initSearchBar() {
	$(".menu-right .menu-search, .menu-main > .menu-search, .menu-main > .menu-search .search-close").off(".searchInteraction");
	$(document).off("touchstart.searchInteraction");

	function searchOpen() {
		closeMenu();
		$('.menu-searchlist').show();
		openOverlay();
		openDesktopMenu();
		MenuState.searchIsOpen = true;

		if (smallScreen.matches) {
			$('[data-buttongroup="search"]').css('display','flex');
			$('.menu-search-input').show();
			$(".menu-search-input input").focus();
			// $('.menu-search-output').css("display", "flex");
		} else if (mediumScreen.matches) {
			$(".menu-main > .menu-search input").focus();
			$(".menu-right, .menu-middle .menu-list").hide();
			$(".menu-main > .menu-search").css("display", "flex");
			$(".menu-main > .menu-search .menu-close").show();
		} else if (largeScreen.matches) {
			$(".menu-main > .menu-search input").focus();
			$(".menu-right, .menu-middle .menu-list").hide();
			$(".menu-main > .menu-search .menu-close").show();
		}
	}

	function searchClose() {
		$(document.activeElement).blur();
		$('.menu-searchlist').hide();
		closeOverlay();
		closeDesktopMenu();
		closeButtonGroup();
		MenuState.searchIsOpen = false;

		if (smallScreen.matches) {
			// $('[data-buttongroup="search"]').hide();
			$('.menu-search-input').hide();
			// $('.menu-search-output').hide();
		} else if (mediumScreen.matches) {
			$(".menu-right, .menu-middle .menu-list").show();
			$(".menu-main > .menu-search, .menu-main > .menu-search .menu-close").hide();
		} else if (largeScreen.matches) {
			$(".menu-right, .menu-middle .menu-list").show();
			$(".menu-main > .menu-search, .menu-main > .menu-search .menu-close").hide();
		}
	}

	if (!MenuState.isTouchDevice) {
		$(".menu-position").on("mouseleave.menuInteraction", function () {
			MenuState.fadeOutTimeout = setTimeout(() => {
				searchClose();
			}, MenuConfig.closeDelay);
		});
	}

	function checkScreenSize() {
		$(".menu-right .menu-search").off(".searchInteraction");
        $(".menu-main > .menu-search .search-close").off(".searchInteraction");
        $(".menu-main > .menu-search input").off(".searchInteraction");

		if (smallScreen.matches) {
			$(".menu-right .menu-search").on("click.searchInteraction", function (e) {
				e.stopPropagation();
				searchOpen();
			});
			$(".menu-curtain, .search-close").on("click.searchInteraction", function (e) {
				e.stopPropagation();
				searchClose();
			});
			$(".menu-search-input .search-close").on("click.searchInteraction", function (e) {
				e.stopPropagation();
				searchClose();
			});
		} else if (mediumScreen.matches) {
			$(".menu-right .menu-search").on("click.searchInteraction", function (e) {
				e.stopPropagation();
				searchOpen();
			});
			$(".menu-main > .menu-search .search-close").on("click.searchInteraction", function (e) {
				e.stopPropagation();
				searchClose();
			});
		} else if (largeScreen.matches) {
			$(".menu-main > .menu-search input").on("click.searchInteraction", function (e) {
				e.stopPropagation();
				searchOpen();
			});
			$(".menu-main > .menu-search .search-close").on("click.searchInteraction", function (e) {
				e.stopPropagation();
				searchClose();
			});
		}
	}

	checkScreenSize();
	smallScreen.addEventListener("change", checkScreenSize);
	mediumScreen.addEventListener("change", checkScreenSize);
	largeScreen.addEventListener("change", checkScreenSize);

	// For touch devices: Global search close when tapping outside search container.
	$(document).on("touchstart.searchInteraction", function (e) {
		if ($(e.target).closest(".reviews-modal, .reviews-buttongroup, localization-form").length > 0) {
		    return; // Do nothing if tapped inside the reviews section
		  }

		const tappedInside = $(e.target).closest(".menu-desktop, .menu-mobile, .menu-main").length > 0;
		const tappedOnSearch = $(e.target).closest(".menu-search").length > 0;

		if (tappedOnSearch) {
			setTimeout(() => {
				if (mediumScreen.matches || largeScreen.matches) {
					searchOpen();
				}
			}, 150);
		} else if (!tappedInside) {
			setTimeout(() => {
				$(".menu-right, .menu-middle .menu-list").show();
				$(".menu-main > .menu-search, .menu-main > .menu-search .menu-close").hide();
				searchClose();
			}, 150);
		}
	});

	// Search input
	let debounceTimer;
	$('.searchInput').on('input', function() {
		const query = $(this).val();
		$('.searchInput').not(this).val(query);
		clearTimeout(debounceTimer);
		debounceTimer = setTimeout(function() {
			searchQuery(query);
		}, 200);
	});
	function searchQuery(query) {
		console.log("Searching for:", query);
		if (query) {
			$('.search-clear').show();
			// $('.search-results').removeClass('disabled');
			// $('.menu-searchlist').show();
			$('.menu-search-output').show();
		} else {
			$('.search-clear').hide();
			// $('.search-results').addClass('disabled');
			// $('.menu-searchlist').hide();
			$('.menu-search-output').hide();
		}
	}
	$(".search-clear").on('click', function() {
		$('.searchInput').val('').trigger('input').focus();
		console.log('search cleared');
	});
}

// ------------------------------
// Initialization
// ------------------------------
function initMenuSystem() {
	initMainMenuInteractions();
	initSearchBar();
}

// Run initial setup
initMenuSystem();

// Re-initialize on window resize if touch support changes.
$(window).on("resize.menuInteraction", function () {
	const newIsTouch = window.matchMedia("(pointer: coarse)").matches;
	if (newIsTouch !== MenuState.isTouchDevice) {
		MenuState.isTouchDevice = newIsTouch;
		initMenuSystem();
	}
});

// Expose functions for other scripts:
window.MenuControls = {
	openOverlay,
	closeOverlay,
	openDesktopMenu,
	closeDesktopMenu,
	closeMenuAndOverlay
};

// Header Sliders
const headerSlider = $('.header--top-slider');
const mediaQuery = window.matchMedia('(min-width: 767px) and (max-width: 990px)');
const handleSlider = () => {
if (mediaQuery.matches) {
		!headerSlider.hasClass('slick-initialized') && headerSlider.slick({
			slidesToShow: 1,
			arrows: false,
			autoplay: true,
			pauseOnHover: false,
		});
	} else {
		headerSlider.hasClass('slick-initialized') && headerSlider.slick('unslick');
	}
};
handleSlider();
mediaQuery.addEventListener('change', handleSlider);

// Table of Contents/Product/Cart/Overview Buttongroup
var terms = ["toc", "product", "cart", "overview", "reviews"];
var buttonmediaQuery = window.matchMedia('(max-width: 990px)');
terms.forEach(function(term) {
	$('.' + term + '-open').click(function() {
		if(buttonmediaQuery.matches){
			$('body').addClass('no-scroll');
			$('.buttongroup[data-buttongroup="' + term + '"]').addClass('active');
			$('.buttongroup-group[data-buttongroup="' + term + '-closed"]').removeClass('active');
			$('.buttongroup-group[data-buttongroup="' + term + '-open"]').addClass('active');
			$('.overlay').fadeIn(700);
		}
	});

	$('.overview-open').click(function(){
		if(buttonmediaQuery.matches){
			$('.buttongroup-filtergroup[data-filtergroup="menu"]').addClass('active');
		}
	});

	$('.' + term + '-close').click(function() {
		$('.overlay').fadeOut(700);
		$('.buttongroup-group[data-buttongroup="' + term + '-closed"]').addClass('active');
		$('.buttongroup-group[data-buttongroup="' + term + '-open"]').removeClass('active');
		$('.buttongroup[data-buttongroup="' + term + '"]').removeClass('active');
		$('.buttongroup-filtergroup').removeClass('active');
		$('body').removeClass('no-scroll');
	});

	$('.' + term + '-index a').click(function() {
		$('.overlay').fadeOut(700);
		$('.buttongroup-group[data-buttongroup="' + term + '-closed"]').addClass('active');
		$('.buttongroup-group[data-buttongroup="' + term + '-open"]').removeClass('active');
		$('.buttongroup[data-buttongroup="' + term + '"]').removeClass('active');
		$('body').removeClass('no-scroll');
	});
});

$('.overview-filterlist .filter-option').click(function() {
	var list = $(this).data('filtertype');
	$('.buttongroup-filtergroup').removeClass('active');
	$('.buttongroup-filtergroup[data-filtergroup="' + list + '"]').addClass('active');
});

$('.overview-back').click(function() {
	$('.buttongroup-filtergroup').removeClass('active');
	$('.buttongroup-filtergroup[data-filtergroup="menu"]').addClass('active');
});

// FAQ & Table Wrapping
$('.user-content').each(function(){
	var html = $(this).html();
	// Process [faqcontainer]...[/faqcontainer] blocks
	html = html.replace(/\[faqcontainer\]([\s\S]*?)\[\/faqcontainer\]/g, function(match, innerContent) {
	// Replace each [faq] within the container
	var processedContent = innerContent.replace(/\[faq\]([\s\S]*?)\|([\s\S]*?)\[\/faq\]/g, function(match, question, answer) {
	return `
		<div class="faq-item">
			<div class="faq-title">
				<h3>${question.trim()}</h3>
				<svg fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path clip-rule="evenodd" d="m4.29289 7.29289c.39053-.39052 1.02369-.39052 1.41421 0l4.2929 4.29291 4.2929-4.29291c.3905-.39052 1.0237-.39052 1.4142 0 .3905.39053.3905 1.02369 0 1.41422l-5 4.99999c-.3905.3905-1.02368.3905-1.4142 0l-5.00001-4.99999c-.39052-.39053-.39052-1.02369 0-1.41422z" fill-rule="evenodd"/></svg>
			</div>
			<div class="faq-content">
				<div class="faq-inner">
					<p>${answer.trim()}</p>
				</div>
			</div>
		</div>`;
	});
	return `<div class="faq">${processedContent}</div>`;
	});
	$(this).html(html);

	// Table wrapper
	$(this).find('table').each(function() {
		if (!$(this).parent('.table-wrapper').length) {
			$(this).wrap('<div class="table-wrapper"></div>');
		}
	});
});
$(".faq-title").click(function () {
	var $item = $(this).closest(".faq-item");
	var $content = $item.find(".faq-content");

	if (!$item.hasClass("active")) {
		$(".faq-item").removeClass("active").find(".faq-content").slideUp();
		$item.addClass("active");
		$content.slideDown();
	} else {
		$item.removeClass("active");
		$content.slideUp();
	}
});

// SVG Converter
document.querySelectorAll("svg[data-url]").forEach(async (svgElement) => {
const svgUrl = svgElement.getAttribute("data-url"); // Get the file path
const dataSize = svgElement.getAttribute("data-size"); // Get the desired size

try {
  // Fetch the SVG file
  const response = await fetch(svgUrl);

  if (!response.ok) {
	// If the file couldn't be fetched, throw an error
	throw new Error(`Failed to fetch SVG from ${svgUrl}: ${response.status} ${response.statusText}`);
  }

  // Parse the SVG content
  const svgContent = await response.text();
  const parser = new DOMParser();
  const svgDoc = parser.parseFromString(svgContent, "image/svg+xml");
  const newSvgElement = svgDoc.documentElement;

  // If `data-size` is present, adjust the size of the SVG
  if (dataSize) {
	const size = parseInt(dataSize, 10);
	if (!isNaN(size)) {
	  // Get the viewBox of the SVG to maintain the aspect ratio
	  const viewBox = newSvgElement.getAttribute("viewBox").split(" ");
	  const viewBoxWidth = parseFloat(viewBox[2]) || 20; // Default to 20 if viewBox is invalid
	  const viewBoxHeight = parseFloat(viewBox[3]) || 20; // Default to 20 if viewBox is invalid

	  // Calculate scale factors based on width and height
	  const scaleX = size / viewBoxWidth;
	  const scaleY = size / viewBoxHeight;
	  const scale = Math.min(scaleX, scaleY); // Use the smaller scale factor to maintain the aspect ratio

	  // Set the new width and height based on the scale factor
	  newSvgElement.setAttribute("width", viewBoxWidth * scale);
	  newSvgElement.setAttribute("height", viewBoxHeight * scale);
	}
  } else {
	// If no `data-size` is specified, retain the original size based on viewBox
	const viewBox = newSvgElement.getAttribute("viewBox").split(" ");
	const viewBoxWidth = parseFloat(viewBox[2]) || 20;
	const viewBoxHeight = parseFloat(viewBox[3]) || 20;
	newSvgElement.setAttribute("width", viewBoxWidth);
	newSvgElement.setAttribute("height", viewBoxHeight);
  }

	const id = svgElement.getAttribute("id");
	if (id) {
		newSvgElement.setAttribute("id", id);
	}
	const classes = svgElement.getAttribute("class");
	if (classes) {
		newSvgElement.setAttribute("class", classes);
	}

  // Replace the placeholder <svg> with the fetched SVG content
  svgElement.replaceWith(newSvgElement);
} catch (error) {
  console.error("Error loading inline SVG:", error);

  // If there's an error, display debug information in the placeholder
  svgElement.innerHTML = `
	<text x="10" y="20" font-size="12" fill="red">
	  Failed to load: ${svgUrl}
	</text>
  `;
  svgElement.setAttribute("viewBox", "0 0 300 50"); // Set a basic viewBox for error message
}
});

// Notifications
$('.notification-close').click(function(){
	$(this).parent().slideUp();
});

}); // End jquery

$('.slider--products, .slider--recents').on('mousedown touchend', function(){
	$(this).addClass('clicked');
});
$('.slider--products, .slider--recents').hover(function(){
	$(this).addClass('hovered');
}, function(){
	$(this).removeClass('hovered clicked');
});

// Hompage Product Slider
$('.slider--products').slick({
	autoplay: false,
	dots: false,
	arrows: true,
	variableWidth: true,
	infinite: false,
	prevArrow: '<button type="button" class="slick-prev" aria-label="previous"><svg fill="none" height="20" viewBox="0 0 21 20" width="21" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m11.2084 3.45891c.3905.39052.3905 1.02369 0 1.41421l-4.12622 4.12623h9.25242c.5523 0 1 .44771 1 1 0 .55225-.4477.99995-1 .99995h-9.25242l4.12622 4.1263c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.41421 0l-5.83333-5.8333c-.39052-.3906-.39052-1.02374 0-1.41426l5.83333-5.83333c.39051-.39053 1.02371-.39053 1.41421 0z"  fill-rule="evenodd"/></svg></button>',
	nextArrow: '<button type="button" class="slick-next" aria-label="next"><svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m9.29322 3.4594c.39052-.39053 1.02368-.39053 1.41418 0l5.8334 5.83333c.3905.39052.3905 1.02367 0 1.41417l-5.8334 5.8334c-.3905.3905-1.02366.3905-1.41418 0-.39053-.3905-.39053-1.0237 0-1.4142l4.12618-4.1263h-9.25241c-.55228 0-1-.4477-1-.99996 0-.55229.44772-1 1-1h9.25241l-4.12618-4.12623c-.39053-.39052-.39053-1.02369 0-1.41421z" fill-rule="evenodd"/></svg></button>',
	swipe: true,
	mobileFirst: true,
	responsive: [
		{
			breakpoint: 1,
			settings: {
				slidesToScroll: 2,
				slidesToShow: 2,
			}
		},
		{
			breakpoint: 768,
			settings: {
				slidesToScroll: 3,
				slidesToShow: 3,
			}
		},
		{
			breakpoint: 991,
			settings: {
				slidesToScroll: 4,
				slidesToShow: 4,
			}
		},
		{
			breakpoint: 1240,
			settings: {
				slidesToScroll: 5,
				slidesToShow: 5,
			}
		}
	]
});

// Listen for the recentlyViewedLoaded event
document.addEventListener('recentlyViewedLoaded', function(event) {
	const container = event.detail.container;
	if (container) {
		setTimeout(function() {
			$(container).slick({
				autoplay: false,
				dots: false,
				arrows: true,
				variableWidth: true,
				infinite: false,
				prevArrow: '<button type="button" class="slick-prev" aria-label="previous"><svg fill="none" height="20" viewBox="0 0 21 20" width="21" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m11.2084 3.45891c.3905.39052.3905 1.02369 0 1.41421l-4.12622 4.12623h9.25242c.5523 0 1 .44771 1 1 0 .55225-.4477.99995-1 .99995h-9.25242l4.12622 4.1263c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.41421 0l-5.83333-5.8333c-.39052-.3906-.39052-1.02374 0-1.41426l5.83333-5.83333c.39051-.39053 1.02371-.39053 1.41421 0z"  fill-rule="evenodd"/></svg></button>',
				nextArrow: '<button type="button" class="slick-next" aria-label="next"><svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m9.29322 3.4594c.39052-.39053 1.02368-.39053 1.41418 0l5.8334 5.83333c.3905.39052.3905 1.02367 0 1.41417l-5.8334 5.8334c-.3905.3905-1.02366.3905-1.41418 0-.39053-.3905-.39053-1.0237 0-1.4142l4.12618-4.1263h-9.25241c-.55228 0-1-.4477-1-.99996 0-.55229.44772-1 1-1h9.25241l-4.12618-4.12623c-.39053-.39052-.39053-1.02369 0-1.41421z" fill-rule="evenodd"/></svg></button>',
				swipe: true,
				mobileFirst: true,
				responsive: [
					{
						breakpoint: 1,
						settings: {
							slidesToScroll: 2,
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToScroll: 3,
							slidesToShow: 3,
						}
					},
					{
						breakpoint: 991,
						settings: {
							slidesToScroll: 4,
							slidesToShow: 4,
						}
					},
					{
						breakpoint: 1240,
						settings: {
							slidesToScroll: 5,
							slidesToShow: 5,
						}
					}
				]
			});
		}, 10);
	}
});

// Homepage Category slider
$('.slider--header').on('mousedown touchend', function(){
	$(this).addClass('clicked');
});
$('.slider--header').hover(function(){
	$(this).addClass('hovered');
}, function(){
	$(this).removeClass('hovered clicked');
});
$('.slider--header').slick({
	autoplay: false,
	swipeToSlide: true,
	dots: false,
	arrows: true,
	variableWidth: true,
	touchThreshold: 100,
	infinite: true,
	prevArrow: '<button type="button" class="slick-prev" aria-label="previous"><svg fill="none" height="20" viewBox="0 0 21 20" width="21" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m11.2084 3.45891c.3905.39052.3905 1.02369 0 1.41421l-4.12622 4.12623h9.25242c.5523 0 1 .44771 1 1 0 .55225-.4477.99995-1 .99995h-9.25242l4.12622 4.1263c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.41421 0l-5.83333-5.8333c-.39052-.3906-.39052-1.02374 0-1.41426l5.83333-5.83333c.39051-.39053 1.02371-.39053 1.41421 0z"  fill-rule="evenodd"/></svg></button>',
	nextArrow: '<button type="button" class="slick-next" aria-label="next"><svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m9.29322 3.4594c.39052-.39053 1.02368-.39053 1.41418 0l5.8334 5.83333c.3905.39052.3905 1.02367 0 1.41417l-5.8334 5.8334c-.3905.3905-1.02366.3905-1.41418 0-.39053-.3905-.39053-1.0237 0-1.4142l4.12618-4.1263h-9.25241c-.55228 0-1-.4477-1-.99996 0-.55229.44772-1 1-1h9.25241l-4.12618-4.12623c-.39053-.39052-.39053-1.02369 0-1.41421z" fill-rule="evenodd"/></svg></button>',
});

// Ticks & Pros and Cons
const ICON_TICK = `<svg viewBox="0 0 21 20" width="20" height="20" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 20c-5.5 0-10-4.5-10-10S5 0 10.5 0s10 4.5 10 10-4.5 10-10 10zm0-18.75c-4.8 0-8.75 3.9-8.75 8.75s3.9 8.75 8.75 8.75 8.75-3.9 8.75-8.75S15.3 1.25 10.5 1.25zm-1.43 12.32l6.25-6.25a.625.625 0 10-.88-.88l-5.81 5.8-2.06-2.05a.625.625 0 10-.88.88l2.5 2.5c.12.12.28.18.44.18s.32-.06.44-.18z"/></svg>`;
const ICON_PLUS = `<svg viewBox="0 0 21 21" width="21" height="21" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.84 1.95c-4.52 0-8.18 3.66-8.18 8.18 0 4.52 3.66 8.18 8.18 8.18s8.18-3.66 8.18-8.18c0-4.52-3.66-8.18-8.18-8.18zM.84 10.13c0-5.52 4.48-10 10-10 5.52 0 10 4.48 10 10 0 5.52-4.48 10-10 10-5.52 0-10-4.48-10-10zm10-4.55c.5 0 .91.41.91.91v2.73h2.73c.5 0 .9.4.9.91 0 .5-.4.9-.9.9h-2.73v2.73c0 .5-.41.91-.91.91s-.9-.41-.9-.91v-2.73H7.2c-.5 0-.9-.4-.9-.9 0-.51.4-.91.9-.91h2.73V6.49c0-.5.4-.91.91-.91z"/></svg>`;
const ICON_MINUS = `<svg viewBox="0 0 21 21" width="21" height="21" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.84 1.95c-4.52 0-8.18 3.66-8.18 8.18 0 4.52 3.66 8.18 8.18 8.18s8.18-3.66 8.18-8.18c0-4.52-3.66-8.18-8.18-8.18zM.84 10.13c0-5.52 4.48-10 10-10 5.52 0 10 4.48 10 10 0 5.52-4.48 10-10 10-5.52 0-10-4.48-10-10zm5.46 0c0-.5.4-.91.9-.91h7.28c.5 0 .91.41.91.91 0 .5-.41.91-.91.91H7.2c-.5 0-.9-.41-.9-.91z"/></svg>`;
document.querySelectorAll("ul.ticks, ul.pros").forEach((ul) => {
	ul.querySelectorAll("li").forEach((li) => {
		let svgString = "";

		if (ul.classList.contains("ticks")) {
			svgString = ICON_TICK;
		} else if (ul.classList.contains("pros")) {
			if (li.classList.contains("pro")) {
				svgString = ICON_PLUS;
			} else if (li.classList.contains("con")) {
				svgString = ICON_MINUS;
			} else {
				return;
			}
		}

		let div = document.createElement("div");
		div.innerHTML = svgString.trim();
		let svgElement = div.firstChild;

		if (!li.querySelector("span")) {
			let span = document.createElement("span");
			while (li.firstChild) {
				span.appendChild(li.firstChild);
			}
			li.appendChild(span);
		}
		li.prepend(svgElement);
	});
});

// YSA Manager
function setupButtonGroupObserver(container) {
  const updateVisibility = () => {
    const anyButtonGroupVisible = Array.from(
      document.querySelectorAll(".buttongroup")
    ).some((group) => group.offsetWidth > 0 || group.offsetHeight > 0);

    const isBannerActive =
      document.querySelector(".single-banner.headroom--not-top") !== null;

    container.classList.toggle(
      "ysa-buttongroup",
      anyButtonGroupVisible || isBannerActive
    );
  };

  const visibilityObserver = new MutationObserver(updateVisibility);
  visibilityObserver.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ["style", "class"],
  });

  updateVisibility();
}

const ysaContainerObserver = new MutationObserver((mutations, observer) => {
  // Use querySelectorAll to get all matching elements
  const containers = document.querySelectorAll(
    ".ysa_hided_popup_div, .ysa_popup-div"
  );

  if (containers.length > 0) {
    containers.forEach((container) => {
      // Apply the class and setup observer for each found container
      container.classList.add("ysa-manager");
      setupButtonGroupObserver(container);
    });
    // Disconnect after finding and processing all initial containers
    observer.disconnect();
  }
});

ysaContainerObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

// Scroll Navigation
document.addEventListener('DOMContentLoaded', function() {
    const tocLinks = document.querySelectorAll('.toc-index a');
    const articles = document.querySelectorAll('h2[id^="artikel-"]');
    const buffer = 100; // Adjust this value to change when the highlight switches

    function updateActiveLink() {
        let currentArticle = '';
        
        articles.forEach(article => {
            const articleTop = article.getBoundingClientRect().top;
            if (articleTop < window.innerHeight - buffer) {
                currentArticle = `#${article.id}`;
            }
        });

        tocLinks.forEach(link => {
            link.classList.remove('active');
            if (link.getAttribute('href') === currentArticle) {
                link.classList.add('active');
            }
        });
    }

    // Throttle scroll events for better performance
    function throttle(fn, wait) {
        let time = Date.now();
        return function() {
            if ((time + wait - Date.now()) < 0) {
                fn();
                time = Date.now();
            }
        };
    }

    // Initial check
    updateActiveLink();

    // Scroll listener
    window.addEventListener('scroll', throttle(updateActiveLink, 100));

    // Smooth scroll for TOC links
    tocLinks.forEach(link => {
	    link.addEventListener('click', function(e) {
	        e.preventDefault();
	        const target = document.querySelector(this.getAttribute('href'));
	        const targetPosition = window.scrollY + target.getBoundingClientRect().top - 150;
	        
	        window.scrollTo({
	            top: targetPosition,
	            behavior: 'smooth'
	        });
	    });
	});
});

// Steps Nav
$(document).ready(function() {
  // Variable to store which nav item (if any) has been clicked (locked)
  var lockedNav = null;
  
  // Helper: remove the active class from all nav links and steps
  function clearActive() {
    $('.steps-nav a').removeClass('active');
    $('.steps-item').removeClass('active');
  }
  
  // Helper: set the active state given a target (e.g. "#step-1")
  function setActive(target) {
    clearActive();
    $('.steps-nav a[href="' + target + '"]').addClass('active');
    $(target).addClass('active');
  }
  
  // ----- NAV HOVER -----
  $('.steps-nav a')
    .on('mouseenter', function() {
      // On hover, always update the active state to match the hovered item.
      var target = $(this).attr('href');
      setActive(target);
    })
    .on('mouseleave', function() {
      // When leaving, if this link isn’t locked, remove its active state.
      if (!$(this).hasClass('locked')) {
        clearActive();
        // If another nav is locked, restore that active state.
        if (lockedNav) {
          setActive(lockedNav);
        }
      }
    });
  
  // ----- STEP ITEM HOVER -----
  $('.steps-item')
    .on('mouseenter', function() {
      var target = '#' + $(this).attr('id');
      setActive(target);
    })
    .on('mouseleave', function() {
      if (!$(this).hasClass('locked')) {
        clearActive();
        if (lockedNav) {
          setActive(lockedNav);
        }
      }
    });
  
  // ----- NAV CLICK (Lock active state) -----
  $('.steps-nav a').on('click', function(e) {
    e.preventDefault(); // prevent the default jump
    lockedNav = $(this).attr('href');
    // Remove any previous locked state…
    $('.steps-nav a').removeClass('locked');
    $('.steps-item').removeClass('locked');
    // …and lock this one:
    $(this).addClass('locked');
    $(lockedNav).addClass('locked');
    setActive(lockedNav);
    
    // Smooth-scroll to the target step item:
    $('html, body').animate({
      scrollTop: $(lockedNav).offset().top
    }, 500);
  });
  
  // ----- SCROLL EVENT: activate step in center of viewport (if nothing is hovered) -----
  $(window).on('scroll', function() {
    // Check if any nav or step is being hovered.
    if ($('.steps-nav a:hover, .steps-item:hover').length > 0) {
      return; // do nothing if a hover is in progress
    }
    
    // If a nav item is locked (clicked), we let that state remain.
    if (lockedNav) {
      return;
    }
    
    // Calculate the vertical center of the viewport.
    var viewportCenter = $(window).scrollTop() + ($(window).height() / 2);
    var closest = null;
    var closestDistance = Infinity;
    
    // Find the .steps-item whose center is closest to the viewport center.
    $('.steps-item').each(function() {
      var $this = $(this);
      var itemTop = $this.offset().top;
      var itemHeight = $this.outerHeight();
      var itemCenter = itemTop + (itemHeight / 2);
      var distance = Math.abs(viewportCenter - itemCenter);
      
      if (distance < closestDistance) {
        closestDistance = distance;
        closest = $this;
      }
    });
    
    if (closest) {
      var id = '#' + closest.attr('id');
      setActive(id);
    }
  });
  
  // Optionally trigger scroll once on load so an active step is set
  $(window).trigger('scroll');
});

document.addEventListener("DOMContentLoaded", () => {
  // Target the new top-level container for our filter sliders
  const sliderContainers = document.querySelectorAll(
    "[data-filter-slider-container]"
  );

  sliderContainers.forEach((container) => {
    // Find all the necessary elements within the container
    const slider = container.querySelector(".filter-slider-input");
    const valueDisplay = container.querySelector("[data-filter-slider-value]");
    const radioInputs = container.querySelectorAll(
      "[data-filter-slider-radios] input[type=radio]"
    );

    // Safety check to make sure all parts are present
    if (!slider || !valueDisplay || radioInputs.length === 0) {
      return;
    }

    // --- NEW: Build the options array by reading data from the DOM ---
    const options = Array.from(radioInputs).map((radio) => ({
      label: radio.dataset.label,
      value: radio.value,
    }));

    // --- From your script: Helper function for visual positioning ---
    function getThumbWidth(slider) {
      let dummy = document.createElement("div");
      dummy.style.width = "var(--thumb-size, 18px)";
      document.body.appendChild(dummy);
      let width = window.getComputedStyle(dummy).width;
      document.body.removeChild(dummy);
      return parseFloat(width) || 18;
    }

    // --- MERGED: The main update function ---
    function updateValue() {
      // --- From your script: Visual calculations ---
      const percent = (slider.value - slider.min) / (slider.max - slider.min);
      const sliderWidth = slider.offsetWidth;
      const thumbWidth = getThumbWidth(slider);
      const newPos = percent * (sliderWidth - thumbWidth);
      valueDisplay.style.left = `${newPos}px`;

      // --- From your script: Update filled track effect ---
      const fillColor = `linear-gradient(to right, #4CAF50 ${
        percent * 100
      }%, #fff ${percent * 100}%)`;
      slider.style.background = fillColor;

      // --- NEW: Get the selected option using the slider's index value ---
      const selectedIndex = parseInt(slider.value, 10);
      const selectedOption = options[selectedIndex];
      if (!selectedOption) return;

      // --- NEW: Update the display text with the correct label ---
      valueDisplay.textContent = selectedOption.label;

      // --- NEW: Check the correct hidden radio button for form submission ---
      radioInputs[selectedIndex].checked = true;
    }

    // --- From your script: Set the initial state ---
    updateValue();

    // --- From your script: All event listeners remain the same ---
    slider.addEventListener("input", updateValue);
    slider.addEventListener("mousedown", () => slider.classList.add("moving"));
    slider.addEventListener("mouseup", () => slider.classList.remove("moving"));
    slider.addEventListener("touchstart", () =>
      slider.classList.add("moving")
    );
    slider.addEventListener("touchend", () =>
      slider.classList.remove("moving")
    );
  });
});

// Input Switch
document.querySelectorAll('.input-switch input').forEach(toggle => {
    function switchState(toggle) {
        let switchContainer = toggle.closest('.input-switch');
        let leftLabel = switchContainer.querySelector('.input-left');
        let rightLabel = switchContainer.querySelector('.input-right');

        if (toggle.checked) {
            rightLabel.classList.add('active');
            leftLabel.classList.remove('active');
        } else {
            leftLabel.classList.add('active');
            rightLabel.classList.remove('active');
        }
    }

    // Initialize state on load
    switchState(toggle);

    // Update state on change
    toggle.addEventListener('change', function() {
        switchState(this);
        let selectedState = this.checked ? this.closest('.input-switch').dataset.right : this.closest('.input-switch').dataset.left;
        console.log("Selected State:", selectedState);
    });
});

// Double Range
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".filter-group").forEach(container => {
    const lowerRange = container.querySelector(".lower-range");
    const upperRange = container.querySelector(".upper-range");
    const lowerTextInput = container.querySelector(".lower-input");
    const upperTextInput = container.querySelector(".upper-input");
    const rangeTrack = container.querySelector(".range-track");

    // Ensure all elements exist, otherwise skip this container
    if (!lowerRange || !upperRange || !lowerTextInput || !upperTextInput || !rangeTrack) {
      // console.warn("Skipping a .filter-content due to missing elements.");
      return;
    }

    const min = parseFloat(lowerRange.min);
    const max = parseFloat(lowerRange.max);

    function updateRangeTrack() {
      const lowerVal = parseFloat(lowerRange.value);
      const upperVal = parseFloat(upperRange.value);
      const currentMax = parseFloat(upperRange.max);
      const lowerPercent = ((lowerVal - min) / (currentMax - min)) * 100;
      const upperPercent = ((upperVal - min) / (currentMax - min)) * 100;
      rangeTrack.style.background = `linear-gradient(to right, #fff ${lowerPercent}%, #4CAF50 ${lowerPercent}%, #4CAF50 ${upperPercent}%, #fff ${upperPercent}%)`;
    }

    function updateLowerSlider() {
      let lowerVal = parseFloat(lowerRange.value);
      let upperVal = parseFloat(upperRange.value);
      if (lowerVal > upperVal) {
        lowerVal = upperVal;
        lowerRange.value = lowerVal;
      }
      const displayValue = Math.floor(lowerVal / 100);
      lowerTextInput.value = lowerTextInput.getAttribute("data-prepend") + lowerVal + lowerTextInput.getAttribute("data-append");
      container.querySelector('input[name="filter.v.price.gte"]').value = lowerVal;
      updateRangeTrack();
    }

    function updateUpperSlider() {
      let lowerVal = parseFloat(lowerRange.value);
      let upperVal = parseFloat(upperRange.value);
      if (upperVal < lowerVal) {
        upperVal = lowerVal;
        upperRange.value = upperVal;
      }
      const displayValue = Math.ceil(upperVal / 100);
      upperTextInput.value = upperTextInput.getAttribute("data-prepend") + upperVal + upperTextInput.getAttribute("data-append");
      container.querySelector('input[name="filter.v.price.lte"]').value = upperVal;
      updateRangeTrack();
    }

    lowerRange.addEventListener("input", updateLowerSlider);
    upperRange.addEventListener("input", updateUpperSlider);

    function getRawValue(value, input) {
      return value.replace(input.getAttribute("data-prepend"), "").replace(input.getAttribute("data-append"), "").trim();
    }

    function formatValue(input) {
      let rawValue = getRawValue(input.value, input);
      input.dataset.rawValue = rawValue;
      input.value = input.getAttribute("data-prepend") + rawValue + input.getAttribute("data-append");
    }

    function updateTextInput(event) {
	  let input = event.target;
	  let raw = parseFloat(
	    getRawValue(input.value, input).replace(",", ".")
	  );
	  if (isNaN(raw)) return;

	  if (input.classList.contains("lower-input")) {
	    if (raw > parseFloat(upperRange.value)) raw = parseFloat(upperRange.value);
	    if (raw < parseFloat(lowerRange.min)) raw = parseFloat(lowerRange.min);
	    lowerRange.value = raw;
	    // Dispatch event to trigger sync and UI updates
	    lowerRange.dispatchEvent(new Event("input", { bubbles: true }));
	  } else if (input.classList.contains("upper-input")) {
	    if (raw < parseFloat(lowerRange.value)) raw = parseFloat(lowerRange.value);
	    if (raw > parseFloat(upperRange.max)) raw = parseFloat(upperRange.max);
	    upperRange.value = raw;
	    // Dispatch event to trigger sync and UI updates
	    upperRange.dispatchEvent(new Event("input", { bubbles: true }));
	  }
	}

	[lowerTextInput, upperTextInput].forEach((input) => {
	  input.addEventListener(
	    "focus",
	    () => (input.value = getRawValue(input.value, input))
	  );
	  input.addEventListener("blur", (event) => {
	    formatValue(input);
	    updateTextInput(event);
	  });
	  input.addEventListener(
	    "input",
	    () => (input.dataset.rawValue = input.value.trim())
	  );
	  // Also trigger on Enter key
	  input.addEventListener("keydown", (event) => {
	    if (event.key === "Enter") {
	      event.preventDefault();
	      input.blur();
	    }
	  });
	});

    // Moving class trigger
    function addMovingClass() {
      this.classList.add("moving");
    }

    function removeMovingClass() {
      this.classList.remove("moving");
    }

    [lowerRange, upperRange].forEach(slider => {
      slider.addEventListener("mousedown", addMovingClass);
      slider.addEventListener("mouseup", removeMovingClass);
      slider.addEventListener("touchstart", addMovingClass);
      slider.addEventListener("touchend", removeMovingClass);
    });

    updateLowerSlider();
    updateUpperSlider();
  });
});

// Star Rating
document.addEventListener("DOMContentLoaded", () => {
  // Function to update star classes and the .star-value text based on the rating value
  function updateStarsAndValue(container, rating) {
    const stars = container.querySelectorAll('.star');
    const maxRating = stars.length;

    stars.forEach(star => {
      // Ensure the data-star-rating attribute is an integer for comparison
      const starRating = parseInt(star.getAttribute('data-star-rating'), 10);
      if (!isNaN(starRating) && starRating <= rating) {
        star.classList.add('active');
      } else {
        star.classList.remove('active');
      }
    });

    // Update the .star-value display if it exists
    const starValueDiv = container.querySelector('.star-value');
    if (starValueDiv) {
      // Ensure rating doesn't exceed maxRating for display
      const displayRating = Math.min(rating, maxRating);
      // Ensure rating is not negative for display
      const finalDisplayRating = Math.max(0, displayRating);
      starValueDiv.textContent = `${finalDisplayRating}/${maxRating}`;
    }
  }

  // Process each star-rating container
  document.querySelectorAll('.star-rating').forEach(container => {
    const stars = container.querySelectorAll('.star');
    const maxRating = stars.length;

    // First, assign sequential data-star-rating attributes to all stars in this container.
    // This must happen before any calls to updateStarsAndValue that rely on this attribute.
    stars.forEach((star, index) => {
      star.setAttribute('data-star-rating', index + 1);
    });


    // Initialize the .star-value display (optional: set to "0/maxRating")
    const starValueDiv = container.querySelector('.star-value');
    if (starValueDiv) {
      // Initial display can be 0/maxRating or based on data-rating if it exists
       starValueDiv.textContent = `0/${maxRating}`; // Default initial display
    }

    // Check for a data-rating attribute and initialize if present
    const initialRatingAttr = container.getAttribute('data-rating');
    if (initialRatingAttr) {
      const initialRating = parseInt(initialRatingAttr, 10);
      // Ensure the parsed rating is a number and within a reasonable range (0 to maxRating)
      if (!isNaN(initialRating) && initialRating >= 0 && initialRating <= maxRating) {
        updateStarsAndValue(container, initialRating);
      } else if (!isNaN(initialRating) && initialRating > maxRating){
          // Handle cases where data-rating is higher than available stars
           updateStarsAndValue(container, maxRating); // Cap at max available stars
      }
    }

    // Add click listeners after setting data-star-rating and potential initial state
    stars.forEach(star => {
      star.addEventListener('click', function() {
        const rating = parseInt(this.getAttribute('data-star-rating'), 10);
        const group = container.getAttribute('data-star-group');

        if (group) {
          // Update all containers with the same group attribute
          document.querySelectorAll(`.star-rating[data-star-group="${group}"]`)
            .forEach(groupContainer => {
              updateStarsAndValue(groupContainer, rating);
            });
        } else {
          // Update only the current container if no group is set
          updateStarsAndValue(container, rating);
        }
        console.log("Selected rating:", rating);

        // Optional: Trigger a custom event or update a hidden input for form submission
        // Example using a hidden input:
        const hiddenInput = container.querySelector('input[type="hidden"][name="rating"]');
        if (hiddenInput) {
            hiddenInput.value = rating;
        }
      });
    });
  });
});


// Filters Folding
$('.filter-fold').each(function(){
	var $this = $(this);
	var $content = $this.parent().next();
	$this.click(function(){
		$this.toggleClass('close');
		if($this.hasClass('close')){
			$content.slideUp();
		} else {
			$content.slideDown();
		}
	});
});

// Filter Tags
$('.filter-tags .tag').each(function(){
	var $this = $(this);
	var $button = $('button', this);
	$button.click(function(){
		$this.remove();
	});
});

// Custom Select
document.querySelectorAll("select.custom-select").forEach(function(select) {
	// Create the custom wrapper div
	const wrapper = document.createElement("div");
	wrapper.className = "custom-select-wrapper";

	// Create a button to act as the trigger for the dropdown
	const trigger = document.createElement("button");
	trigger.setAttribute("type", "button");
	trigger.className = "custom-select-trigger";
	// Accessibility attributes:
	trigger.setAttribute("aria-haspopup", "listbox");
	trigger.setAttribute("aria-expanded", "false");
	// Set initial text to the currently selected option text
	trigger.textContent = select.options[select.selectedIndex]?.textContent || "Select an option";

	// Create the custom options list
	const list = document.createElement("ul");
	list.className = "custom-options";
	list.setAttribute("role", "listbox");

	// Build the list items from each <option>
	Array.from(select.options).forEach(function(option) {
	  const li = document.createElement("li");
	  li.className = "custom-option";
	  li.setAttribute("role", "option");
	  li.setAttribute("data-value", option.value);
	  li.setAttribute("tabindex", "0"); // Make it focusable for keyboard users
	  li.textContent = option.textContent;
	  if(option.selected) {
	    li.classList.add("selected");
	  }
	  list.appendChild(li);

	  // When an option is clicked, update the trigger and the original select
	  li.addEventListener("click", function() {
	    trigger.textContent = option.textContent;
	    select.value = option.value;
	    // Optionally, dispatch a change event if needed by other scripts
	    select.dispatchEvent(new Event("change"));
	    // Update selected styling
	    list.querySelectorAll(".custom-option").forEach(item => item.classList.remove("selected"));
	    li.classList.add("selected");
	    // Close the list
	    list.classList.remove("open");
	    trigger.setAttribute("aria-expanded", "false");

		if (select.hasAttribute("data-sort-select")) {
			const url = new URL(window.location.href);
			url.searchParams.set("sort_by", select.value);
			window.location = url.toString();
		} else {
			select.dispatchEvent(new Event("change"));
		}
	  });

	  // Keyboard accessibility: select with Enter or Space
	  li.addEventListener("keydown", function(e) {
	    if (e.key === "Enter" || e.key === " ") {
	      e.preventDefault();
	      li.click();
	    }
	  });
	});

	// Toggle the dropdown on trigger click
	trigger.addEventListener("click", function() {
	  const isOpen = list.classList.contains("open");
	  if (isOpen) {
	    list.classList.remove("open");
	    trigger.setAttribute("aria-expanded", "false");
	  } else {
	    list.classList.add("open");
	    trigger.setAttribute("aria-expanded", "true");
	    // Optionally, set focus on the first option for easier keyboard navigation
	    const firstOption = list.querySelector(".custom-option");
	    if (firstOption) {
	      firstOption.focus();
	    }
	  }
	});

	// Close the custom select if clicking outside of it
	document.addEventListener("click", function(e) {
	  if (!wrapper.contains(e.target)) {
	    list.classList.remove("open");
	    trigger.setAttribute("aria-expanded", "false");
	  }
	});

	// Insert the custom widget in the DOM before the original select
	select.parentNode.insertBefore(wrapper, select);
	wrapper.appendChild(trigger);
	wrapper.appendChild(list);
	// Hide the original select element, but keep it in the DOM for form submissions
	select.style.display = "none";
});

// Footer
$('.footer-email').click(function(){
	$(this).toggleClass('active');
	$('.footer-newsletter').toggleClass('active');
});

// Accordion
$('.accordion').each(function() {
  const $accordion = $(this);
  const $items = $accordion.find('.accordion-item');
  
  // Hide all product selection areas initially
  $accordion.find('.accordion-selection').hide();
  
  // Button selection within accordion content
  $accordion.find('.accordion-buttons .button').click(function() {
    const $button = $(this);
    const $buttonGroup = $button.closest('.accordion-buttons').find('.button');
    const $accordionContent = $button.closest('.accordion-content');
    
    $buttonGroup.removeClass('active');
    $button.addClass('active');
    
    if ($button.hasClass('accordion--yes')) {
      // Show product selection if "Yes" is clicked
      $accordionContent.find('.accordion-selection').show();
    } else if ($button.hasClass('accordion--no')) {
      // Hide selection and remove all active states
      $accordionContent.find('.accordion-selection').hide();
      $accordionContent.find('.product-item').removeClass('active');
    }
  });
  
  // Product item selection
  $accordion.on('click', '.product-item', function() {
    const $product = $(this);
    const $selectionContainer = $product.closest('.accordion-selection');
    
    // Make only this product active in its container
    $selectionContainer.find('.product-item').removeClass('active');
    $product.addClass('active');
  });
  
  // Open accordion item via title click
  $accordion.find('.accordion-title').click(function() {
    const $clickedItem = $(this).closest('.accordion-item');
    toggleAccordionItem($clickedItem);
  });
  
  // Handle "next" elements within accordion content
  $accordion.on('click', '.accordion--next', function() {
    const $currentItem = $(this).closest('.accordion-item');
    const currentIndex = $items.index($currentItem);
    const $nextItem = $items.eq(currentIndex + 1);
    
    if ($nextItem.length) {
      $items.removeClass('active');
      $items.find('.accordion-title').removeClass('active');
      $items.find('.accordion-content').slideUp();
      
      $nextItem.addClass('active');
      $nextItem.find('.accordion-title').addClass('active');
      $nextItem.find('.accordion-content').slideDown();
    }
  });
  
  // Show only first item on load
  $items.not(':first').find('.accordion-content').hide();
  $items.removeClass('active');
  $items.first().addClass('active');
  
  function toggleAccordionItem($item) {
    if ($item.hasClass('active')) return;
    
    $items.removeClass('active');
    $items.find('.accordion-title').removeClass('active');
    $items.find('.accordion-content').slideUp();
    
    $item.addClass('active');
    $item.find('.accordion-title').addClass('active');
    $item.find('.accordion-content').slideDown();
  }
});

// Overview Description
$('.overview-description--reveal').click(function() {
	const $description = $('.overview-description');
	const $this = $(this);

	$description.toggleClass('clamped');
	$this.find('.reveal, .hide').toggle();

	let scrollOffset = 150;
	if (window.matchMedia('(min-width: 991px)').matches) {
		scrollOffset = 200;
	}

	if ($description.hasClass('clamped')) {
		$('html, body').animate({
			scrollTop: $description.offset().top - scrollOffset
		}, 300);
	}
});

// Product Description
$('.product-description--reveal').click(function() {
	const $description = $('.product-description');
	const $this = $(this);

	$description.toggleClass('clamped');
	$this.find('.reveal, .hide').toggle();

	let scrollOffset = 150;
	if (window.matchMedia('(min-width: 991px)').matches) {
		scrollOffset = 200;
	}

	if ($description.hasClass('clamped')) {
		$('html, body').animate({
			scrollTop: $description.offset().top - scrollOffset
		}, 300);
	}
});

// Product Specs
$('.product-specs--reveal').click(function() {
	const $specs = $('.product-specs');
	const $this = $(this);

	$specs.toggleClass('clamped');
	$this.find('.reveal, .hide').toggle();

	let scrollOffset = 150;
	if (window.matchMedia('(min-width: 991px)').matches) {
		scrollOffset = 200;
	}

	if ($specs.hasClass('clamped')) {
		$('html, body').animate({
			scrollTop: $specs.offset().top - scrollOffset
		}, 300);
	}
});

document.addEventListener('DOMContentLoaded', () => {
  const searchInput = document.getElementById('specs-search-input');
  const productSpecsContainer = document.querySelector('.product-specs');

  if (searchInput && productSpecsContainer) {
    searchInput.addEventListener('input', () => {
      const searchTerm = searchInput.value.toLowerCase();
      const specGroups = productSpecsContainer.querySelectorAll('.product-specgroup');

      specGroups.forEach(group => {
        const groupHeader = group.querySelector('h3');
        const dlElements = group.querySelectorAll('dl');
        let groupHasVisibleItems = false;

        dlElements.forEach(dl => {
          const dtElements = dl.querySelectorAll(':scope > dt'); // Select only direct children dt
          dtElements.forEach(dt => {
            const dd = dt.nextElementSibling; // Get the corresponding dd
            let itemText = dt.textContent.toLowerCase();

            if (dd) {
              itemText += ' ' + dd.textContent.toLowerCase();
            }

            if (searchTerm === '' || itemText.includes(searchTerm)) {
              dt.style.display = ''; // Show dt
              if (dd) dd.style.display = ''; // Show dd
              groupHasVisibleItems = true;
            } else {
              dt.style.display = 'none'; // Hide dt
              if (dd) dd.style.display = 'none'; // Hide dd
            }
          });
        });

        // Toggle visibility of the entire group based on its items
        if (groupHasVisibleItems) {
          group.style.display = ''; // Show the group div
          if (groupHeader) groupHeader.style.display = ''; // Show group header
        } else {
          group.style.display = 'none'; // Hide the group div
          if (groupHeader) groupHeader.style.display = 'none'; // Hide group header
        }
      });
    });
  }
});

// Product Main Slider
$('.slider--main').slick({
	lazyLoad: 'ondemand',
	autoplay: false,
	dots: false,
	arrows: true,
	slidesToShow: 1,
	fade: true,
	prevArrow: '<button type="button" class="slick-prev" aria-label="previous"><svg fill="none" height="20" viewBox="0 0 21 20" width="21" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m11.2084 3.45891c.3905.39052.3905 1.02369 0 1.41421l-4.12622 4.12623h9.25242c.5523 0 1 .44771 1 1 0 .55225-.4477.99995-1 .99995h-9.25242l4.12622 4.1263c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.41421 0l-5.83333-5.8333c-.39052-.3906-.39052-1.02374 0-1.41426l5.83333-5.83333c.39051-.39053 1.02371-.39053 1.41421 0z"  fill-rule="evenodd"/></svg></button>',
	nextArrow: '<button type="button" class="slick-next" aria-label="next"><svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m9.29322 3.4594c.39052-.39053 1.02368-.39053 1.41418 0l5.8334 5.83333c.3905.39052.3905 1.02367 0 1.41417l-5.8334 5.8334c-.3905.3905-1.02366.3905-1.41418 0-.39053-.3905-.39053-1.0237 0-1.4142l4.12618-4.1263h-9.25241c-.55228 0-1-.4477-1-.99996 0-.55229.44772-1 1-1h9.25241l-4.12618-4.12623c-.39053-.39052-.39053-1.02369 0-1.41421z" fill-rule="evenodd"/></svg></button>',
});

// Autoplay video when the slide becomes visible
$('.slider--main').on('afterChange', function (event, slick, currentSlide) {
  // Pause all videos
  $('.slider--main video').each(function () {
    this.pause();
    this.currentTime = 0; // Reset video to the beginning
  });

  // Pause all YouTube and Vimeo videos
  $('.slider--main iframe').each(function () {
    var iframe = $(this);
    var src = iframe.attr('src');
    if (src) {
      // Stop playback by removing autoplay from the URL
      iframe.attr('src', src.replace('&autoplay=1', ''));
    }
  });

  // Play the video in the current slide (if it exists)
  var currentVideo = $('.slider--main .slick-slide[data-slick-index="' + currentSlide + '"] video');
  if (currentVideo.length) {
    currentVideo[0].play();
  }

  // Get the current slide
  var currentIframe = $('.slider--main .slick-slide[data-slick-index="' + currentSlide + '"] iframe');
  if (currentIframe.length) {
    var iframe = currentIframe[0];
    var src = $(iframe).attr('src');

    // Check if it's a YouTube or Vimeo video
    if (src.includes('youtube.com')) {
      // Add autoplay and mute parameters for YouTube
      $(iframe).attr('src', src + '&autoplay=1&mute=1');
    } else if (src.includes('vimeo.com')) {
      // Add autoplay and mute parameters for Vimeo
      $(iframe).attr('src', src + '&autoplay=1&muted=1');
    }
  }
});

// Debounce function to limit how often a function is called
const debounce = (func, delay) => {
  let timeout;
  return function(...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), delay);
  };
};

// Refresh the slider on window resize
const refreshMainSlider = debounce(() => {
  $('.slider--main').slick('refresh');
}, 250);

$(window).on('resize', refreshMainSlider);

// Product Thumb Slider
$('.slider--thumb .single-slide').on('click', function(){
	var index = $(this).data('slick-index');
	$('.slider--main').slick('slickGoTo', index);
	$('.slider--thumb .single-slide').removeClass('active');
	$(this).addClass('active');
});

// Product Item Label Handling
document.querySelectorAll('.product-item').forEach(item => {
    const label = item.dataset.label;
    if (label) {
        const color = item.dataset.labelColor;
        const image = item.querySelector('.product-image img');
        if (image) {
            const labelDiv = document.createElement('div');
            labelDiv.className = 'product-label';
            labelDiv.style.background = color;
            labelDiv.textContent = label;
            image.insertAdjacentElement('afterend', labelDiv);
        }
    }
});

// Product Banner
const productBanner = document.querySelector('.product-banner');
if (productBanner) {
	const headroom = new Headroom(productBanner, {
		offset: 300,
		tolerance: { up: 0, down: 5 },
	});
	headroom.init();
}

// Modal
$('.modal--close').click(function(){
	$('body').removeClass('no-scroll');
	$('.modal').parent().fadeOut();
});
$('.modal').on('click', function(e) {
	if ($(e.target).is('.modal')) {
		$('body').removeClass('no-scroll');
		$('.modal').parent().fadeOut();
	}
});
const mediaQuery = window.matchMedia('(min-width: 991px)');
$('.modal--open').click(function(){
	if(mediaQuery){
		var modal = $(this).data('modal');
		$('body').addClass('no-scroll');
		$('.'+modal+'-modal').fadeIn();
	}
});

// Language Switcher
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);

// Add to cart functionality for product items
document.addEventListener('DOMContentLoaded', function() {
	const addButtons = document.querySelectorAll('.product-add[data-add-to-cart]');

	addButtons.forEach(button => {
		button.addEventListener('click', function(e) {
			e.preventDefault();
			e.stopPropagation();

			// Visual feedback
			this.disabled = true;
			this.classList.remove('button--add');
			this.classList.add('button--processing');

			const variantId = this.getAttribute('data-add-to-cart');

			// Add item to cart using fetch API
			fetch('/cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					items: [{
						id: variantId,
						quantity: 1
					}]
				})
			})
			.then(response => {
				if (!response.ok) {
					return response.json().then(errorData => {
						throw new Error(errorData.description || `Error: ${response.status}`);
					});
				}
				return response.json();
			})
			.then(data => {
				button.classList.remove('button--processing');
				button.classList.add('button--success');

				updateCartCount();

				moveToCart(button);

				setTimeout(() => {
					button.disabled = false;
					button.classList.remove('button--success');
					button.classList.add('button--add');
				}, 2000);
			})
			.catch((error) => {
				button.classList.remove('button--processing');
				button.classList.add('button--error');

				if (error.message) {
					console.log(error.message);
				}

				setTimeout(() => {
					button.disabled = false;
					button.classList.remove('button--error');
					button.classList.add('button--add');
				}, 2000);
			});
		});
	});

	function updateCartCount() {
		fetch('/cart.js')
		.then(res => res.json())
		.then(cart => {
			document.querySelectorAll('.cart-count').forEach(el => {
				el.textContent = cart.item_count;
			});
		})
		.catch(error => console.error('Error updating cart count:', error));
	}
});

function moveToCart(button) {
	// Get button position
	const buttonRect = button.getBoundingClientRect();
	const buttonCenterX = buttonRect.left + buttonRect.width / 2;
	const buttonCenterY = buttonRect.top + buttonRect.height / 2;

	// Get cart icon position
	const cartIcon = document.querySelector('.cart-count');
	if (!cartIcon) return;

	const cartRect = cartIcon.getBoundingClientRect();
	const cartCenterX = cartRect.left + cartRect.width / 2;
	const cartCenterY = cartRect.top + cartRect.height / 2;

	// Create ball element
	const ball = document.createElement('div');
	ball.className = 'cart-ball';

	// Set initial position at button center
	ball.style.left = `${buttonCenterX - buttonRect.width / 2}px`;
	ball.style.top = `${buttonCenterY - buttonRect.height / 2}px`;
	ball.style.width = `${buttonRect.width}px`;
	ball.style.height = `${buttonRect.height}px`;
	ball.style.opacity = '1';

	// Append to body
	document.body.appendChild(ball);

	// Trigger animation
	setTimeout(() => {
		ball.style.left = `${cartCenterX - 10}px`; // Assuming final size of 12px
		ball.style.top = `${cartCenterY - 10}px`;  // Centering the 12px ball
		ball.style.width = '20px';
		ball.style.height = '20px';
		ball.style.opacity = '0';
	}, 10);

	// Remove ball after animation completes
	setTimeout(() => {
		if (ball.parentNode) {
			document.body.removeChild(ball);
		}
	}, 1600);
}

// Reviews Clamped
document.addEventListener('DOMContentLoaded', () => {
  const calculateAndSetMaxHeight = (optiscrollElement) => {
    if (!optiscrollElement) return;

    const reviewItems = optiscrollElement.querySelectorAll('.reviews-item');
    let maxHeight = 0;

    reviewItems.forEach(item => {
        const itemHeight = item.offsetHeight;
        if (itemHeight > maxHeight) {
            maxHeight = itemHeight;
        }
    });
	optiscrollElement.style.height = `${maxHeight}px`;
  };

  const reviewItems = document.querySelectorAll('.reviews-item');

  reviewItems.forEach(item => {
    const reviewsContent = item.querySelector('.reviews-content');
    const reviewsMore = item.querySelector('.reviews-more');
    const revealButton = item.querySelector('.reviews-more .reveal');
    const hideButton = item.querySelector('.reviews-more .hide');
    const optiscrollParent = item.closest('.optiscroll');

    if (reviewsContent && reviewsMore && revealButton && hideButton && optiscrollParent) {
      setTimeout(() => {
        const isClamped = reviewsContent.scrollHeight > reviewsContent.clientHeight;
        if (isClamped) {
          item.classList.add('active');
        } else {
           item.classList.remove('active');
           reviewsContent.classList.remove('clamped');
        }
        if (!calculateAndSetMaxHeight.processedOptiscrolls) {
            calculateAndSetMaxHeight.processedOptiscrolls = new Set();
        }
        if (!calculateAndSetMaxHeight.processedOptiscrolls.has(optiscrollParent)) {
             calculateAndSetMaxHeight(optiscrollParent);
             calculateAndSetMaxHeight.processedOptiscrolls.add(optiscrollParent);
        }
      }, 0);

      revealButton.addEventListener('click', () => {
        reviewsMore.classList.add('active');
        reviewsContent.classList.remove('clamped');
        calculateAndSetMaxHeight(item.closest('.optiscroll'));
      });

      hideButton.addEventListener('click', () => {
        reviewsMore.classList.remove('active');
        reviewsContent.classList.add('clamped');
        calculateAndSetMaxHeight(item.closest('.optiscroll'));
      });
    }
  });
});

// Review Submit
$('.reviews--submit').click(function(){
	var $this = $('.reviews--submit');
	$this.prop('disabled', true);
	$this.addClass('button--processing');

	setTimeout(function(){
		$this.removeClass('button--processing');
		$this.addClass('button--success');
	}, 2000);
	// .button--error
	setTimeout(function(){
		$this.prop('disabled', false);
		$this.removeClass('button--success');
	}, 4000);
});

// Energy Label
$(document).ready(function() {
	$('.single-energy').on('click touchstart', function(e) {
		if (!$(e.target).closest('[data-fancybox]').length) {
			e.stopPropagation();
		}
		$('.single-energy').not(this).removeClass('hovered');
		$(this).addClass('hovered');
	});
	$(document).on('click touchstart', function(e) {
		if (!$(e.target).closest('.single-energy').length) {
			$('.single-energy').removeClass('hovered');
		}
	});
	$(document).on('focusin', function(e) {
		if (!$(e.target).closest('.single-energy').length) {
			$('.single-energy').removeClass('hovered');
		}
	});
});

//Haptic Feedback
document.addEventListener('DOMContentLoaded', () => {
  const interactiveElements = document.querySelectorAll('button, a[href]');

  interactiveElements.forEach(element => {
    element.addEventListener('click', () => {
      if ('vibrate' in navigator) {
        navigator.vibrate(50); // Vibrate for 50ms
      }
    });
  });
});

// Warning Banner
// -- Function to set a cookie
function setCookie(name, value, hours) {
	let expires = "";
	if (hours) {
		const date = new Date();
		if (hours < 0) {
			date.setTime(date.getTime() - 1);
		} else {
			date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
		}
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/; samesite=Lax";
}
// -- Function to get a cookie
function getCookie(name) {
	const nameEQ = name + "=";
	const ca = document.cookie.split(';');
	for(let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}
// -- Click state
$(document).ready(function() {
	const cookieName = 'warningBannerState';
	const hourDuration = 1;
	if (getCookie(cookieName) !== 'collapsed') {
		$('.warning-banner').removeClass('warning-banner--collapsed');
	}
	$('.warning-banner-button').on('click', function(event) {
		event.stopPropagation();
		const $mainBanner = $(this).closest('.warning-banner');
		$mainBanner.toggleClass('warning-banner--collapsed');

		if ($mainBanner.hasClass('warning-banner--collapsed')) {
			setCookie(cookieName, 'collapsed', hourDuration);
		} else {
			setCookie(cookieName, '', -1);
		}
	});
	$(document).on('click', '.warning-banner.warning-banner--collapsed', function() {
		$(this).removeClass('warning-banner--collapsed');
		setCookie(cookieName, '', -1);
	});
});

// Overview Filter Collapse
$(document).ready(function() {
	$('.filter-collapse').each(function(){
		const $this = $(this);
		const $prev = $(this).prev();

		$this.click(function(){
			$this.toggleClass('filter--expanded');
			$prev.toggleClass('filter--expanded');
		});
	});
});

